import { clearStorefrontNavCache } from './useStorefrontNav'

/**
 * Tie the storefront nav cache to the session: the cache is process-lived
 * and holds category names, so a logout (an in-SPA route change, no reload)
 * must not leave the previous visit's names for the next one.
 *
 * Installed once from main.js. It subscribes to the store rather than living
 * inside the `logout` action so the lifecycle stays in this module.
 */
export function installStorefrontNavCacheLifecycle(store) {
    store.subscribeAction({
        before: (action) => {
            if (action.type === 'logout') clearStorefrontNavCache()
        },
    })
}
